import { render } from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=template&id=0b520a51&scoped=true"
import script from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=script&lang=js"

import "./ListaContratacoesVigenciaFinalizadaView.vue?vue&type=style&index=0&id=0b520a51&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b520a51"]])

export default __exports__